import React from "react";
import Image, { ImageProps } from "next/image";

import googleIcon from "/public/images/googleIcon.svg";
import facebookIcon from "/public/images/facebookIcon.svg";

type AvatarIconImagePropsType = {
  alt: string;
  imageUrl: string;
  googleComment: boolean;
  facebookComment: boolean;
};
function AvatarIconImage({
  alt,
  imageUrl,
  googleComment,
  facebookComment,
}: AvatarIconImagePropsType) {
  let icon: ImageProps["src"] | null = null;
  let iconAlt: string = "";
  if (googleComment) {
    icon = googleIcon;
    iconAlt = "google";
  }
  if (facebookComment) {
    icon = facebookIcon;
    iconAlt = "facebook";
  }
  console.log(icon);

  return (
    <div className="relative rounded-full ">
      <Image alt={alt} src={imageUrl} width={50} height={50} />
      {icon && (
        <Image
          className="absolute -bottom-1 -right-1 p-[.5px] bg-white rounded-full"
          alt={`${iconAlt} icon`}
          src={icon}
          height={20}
          width={20}
        />
      )}
    </div>
  );
}

export default AvatarIconImage;
